import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=617389b6&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"
import style0 from "./Event.vue?vue&type=style&index=0&id=617389b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617389b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('617389b6')) {
      api.createRecord('617389b6', component.options)
    } else {
      api.reload('617389b6', component.options)
    }
    module.hot.accept("./Event.vue?vue&type=template&id=617389b6&scoped=true", function () {
      api.rerender('617389b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/components/planner/calendar/Event.vue"
export default component.exports